import { UAParser } from 'ua-parser-js';

const getUserAgentInfo = () => {
  const parser = new UAParser();
  const result = parser.getResult();

  return {
    browser: result.browser.name,
    os: result.os.name,
    device: result.device.type || 'desktop',
  };
};

export default getUserAgentInfo;
